import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  pagination: {
    marginTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'row-reverse'
  }
}))
